import { render } from "./tinymce-editor.vue?vue&type=template&id=4b2aef5b"
import script from "./tinymce-editor.vue?vue&type=script&lang=js"
export * from "./tinymce-editor.vue?vue&type=script&lang=js"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__